import { CommonModule, DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbDatepickerModule, NgbModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { HighchartsChartModule } from 'highcharts-angular';
import { CURRENCY_MASK_CONFIG } from 'ng2-currency-mask';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { UsageHistoryService } from 'src/app/services/usage-history.service';
import { pdvGuard } from 'src/app/shared/guards/pdv.guard';
import { RouterGuard } from 'src/app/shared/guards/router.guard';
import { HttpInterceptorBase } from 'src/app/shared/interceptor/http.interceptor';
import { DataService } from 'src/app/shared/services/data.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormValidator } from 'src/app/shared/validators/Validator';
import { AtasComponent } from './components/atas/atas.component';
import { BoletoComponent } from './components/boleto/boleto.component';
import { ContatosComponent } from './components/contatos/contatos.component';
import { MeusEmprestimosComponent } from './components/emprestimo/meus-emprestimos/meus-emprestimos.component';
import { SimularEmprestimoComponent } from './components/emprestimo/simular-emprestimo/simular-emprestimo.component';
import { SolicitacaoBoletoComponent } from './components/emprestimo/solicitacao-boleto/solicitacao-boleto.component';
import { HomeComponent } from './components/home/home.component';
import { MaisAcessadosComponent } from './components/home/mais-acessados/mais-acessados.component';
import { MinhasSolicitacoesComponent } from './components/minhas-solicitacoes/minhas-solicitacoes.component';
import { NotificacoesComponent } from './components/notificacoes/notificacoes/notificacoes.component';
import { MinhasSolicitacoesPdvComponent } from './components/pdv/minhas-solicitacoes/minhas-solicitacoes.component';
import { PdvComponent } from './components/pdv/pdv.component';
import { PeculioComponent } from './components/peculio/peculio.component';
import { SolicitarPeculioComponent } from './components/peculio/solicitar-peculio/solicitar-peculio.component';
import { AnalisePagamentoComponent } from './components/previdencia/analise-pagamento/analise-pagamento.component';
import { AumentoContribuicaoComponent } from './components/previdencia/aumento-contribuicao/aumento-contribuicao.component';
import { DashboardPrevidenciaComponent } from './components/previdencia/dashboard-previdencia/dashboard-previdencia.component';
import { HistoricoContribuicoesComponent } from './components/previdencia/historico-contribuicoes/historico-contribuicoes.component';
import { HistoricoDeclaracaoPPEComponent } from './components/previdencia/p-p-e/historico-declaracao-ppe/historico-declaracao-ppe.component';
import { PPEComponent } from './components/previdencia/p-p-e/p-p-e.component';
import { ProvaVidaComponent } from './components/previdencia/prova-vida/prova-vida.component';
import { ResgateReservaComponent } from './components/previdencia/resgate-reserva/resgate-reserva.component';
import { MinhasSolicitacoesAporteComponent } from './components/previdencia/simulacao-aporte/minhas-solicitacoes-aporte/minhas-solicitacoes-aporte.component';
import { SimulacaoPlanoIVComponent } from './components/previdencia/simulacao-plano-iv/simulacao-plano-iv.component';
import { SimulacaoPrevidenciaComponent } from './components/previdencia/simulacao-previdencia/simulacao-previdencia.component';
import { SolicitacaoAporteComponent } from './components/previdencia/solicitacao-aporte/solicitacao-aporte.component';
import { MinhasSolicitacoesBeneficioComponent } from './components/previdencia/solicitacao-beneficio/minhas-solicitacoes-beneficio/minhas-solicitacoes-beneficio.component';
import { SolicitacaoBeneficioComponent } from './components/previdencia/solicitacao-beneficio/solicitacao-beneficio.component';
import { AdesaoPlanoSaudeComponent } from './components/saude/adesao-plano-saude/adesao-plano-saude.component';
import { HistoricoAdesaoPlanoSaudeComponent } from './components/saude/adesao-plano-saude/historico-adesao-plano-saude/historico-adesao-plano-saude.component';
import { TermoAdesaoComponent } from './components/saude/adesao-plano-saude/termo-adesao/termo-adesao.component';
import { CancelarPlanoComponent } from './components/saude/cancelar-plano/cancelar-plano.component';
import { CartaoDigitalComponent } from './components/saude/cartao-digital/cartao-digital.component';
import { CheckupComponent } from './components/saude/checkup/checkup.component';
import { DashboardSaudeComponent } from './components/saude/dashboard-saude/dashboard-saude.component';
import { ExcluirComponent } from './components/saude/excluir/excluir.component';
import { ExtratoFinanceiroComponent } from './components/saude/extrato-financeiro/extrato-financeiro.component';
import { HistoricoUtilizacaoComponent } from './components/saude/historico-utilizacao/historico-utilizacao.component';
import { MinhasLiberacoesComponent } from './components/saude/minhas-liberacoes/minhas-liberacoes.component';
import { RedeCredenciadaComponent } from './components/saude/rede-credenciada/rede-credenciada.component';
import { MeusReembolsosComponent } from './components/saude/reembolso/meus-reembolsos/meus-reembolsos.component';
import { ReembolsoComponent } from './components/saude/reembolso/reembolso.component';
import { SolicitacaoDeclaracaoComponent } from './components/solicitacao-declaracao/solicitacao-declaracao.component';
import { DadosCadastraisComponent } from './components/usuario/dados-cadastrais/dados-cadastrais.component';
import { InformeRendimentosComponent } from './components/usuario/informe-rendimentos/informe-rendimentos.component';
import { PrivadoRoutingModule } from './privado-routing.module';
import { AporteService } from './services/previdencia/aporte.service';
import { BeneficioService } from './services/previdencia/beneficio.service';
import { PessoaExpostaService } from './services/previdencia/pessoa-exposta.service';
import { SegurancaSocialService } from './services/previdencia/seguranca-social.service';
import { SimuladorLiquidoService } from './services/previdencia/simulador-liquido.service';
import { CartaoService } from './services/saude/cartao.service';
import { CheckupService } from './services/saude/checkup.service';
import { DeclaracaoService } from './services/saude/declaracao.service';
import { HealthService } from './services/saude/health.service';
import { ReembolsoService } from './services/saude/reembolso.service';
import { WhatsappService } from './services/whatsapp/whatsapp.service';
const maskConfig: Partial<IConfig> = {
  validation: false
};
export const customCurrencyMaskConfig = {
  align: "right",
  allowNegative: true,
  allowZero: true,
  decimal: ",",
  precision: 2,
  prefix: "R$ ",
  suffix: "",
  thousands: ".",
  nullable: true
};
// registerLocaleData(ptBr);
@NgModule({
  declarations: [
    DashboardSaudeComponent,
    HomeComponent,
    ExtratoFinanceiroComponent,
    MaisAcessadosComponent,
    HistoricoUtilizacaoComponent,
    CartaoDigitalComponent,
    CheckupComponent,
    CancelarPlanoComponent,
    MinhasLiberacoesComponent,
    ReembolsoComponent,
    RedeCredenciadaComponent,
    DashboardPrevidenciaComponent,
    PPEComponent,
    SimulacaoPrevidenciaComponent,
    SolicitacaoBeneficioComponent,
    SolicitacaoDeclaracaoComponent,
    AnalisePagamentoComponent,
    AumentoContribuicaoComponent,
    ProvaVidaComponent,
    BoletoComponent,
    PeculioComponent,
    MeusEmprestimosComponent,
    SimularEmprestimoComponent,
    SimulacaoPlanoIVComponent,
    DadosCadastraisComponent,
    InformeRendimentosComponent,
    NotificacoesComponent,
    ContatosComponent,
    HistoricoDeclaracaoPPEComponent,
    MinhasSolicitacoesBeneficioComponent,
    AtasComponent,
    MinhasSolicitacoesAporteComponent,
    MeusReembolsosComponent,
    AdesaoPlanoSaudeComponent,
    TermoAdesaoComponent,
    HistoricoAdesaoPlanoSaudeComponent,
    ExcluirComponent,
    HistoricoContribuicoesComponent,
    ResgateReservaComponent,
    MinhasSolicitacoesComponent,
    PdvComponent,
    MinhasSolicitacoesPdvComponent,
    SolicitacaoAporteComponent,
    SolicitacaoBoletoComponent,
    SolicitarPeculioComponent
  ],
  providers: [
    RouterGuard,
    pdvGuard,
    AporteService,
    BeneficioService,
    CartaoService,
    CheckupService,
    DataService,
    DatePipe,
    DeclaracaoService,
    FormValidator,
    HealthService,
    HighchartsChartModule,
    PessoaExpostaService,
    ReembolsoService,
    SegurancaSocialService,
    SimuladorLiquidoService,
    UsageHistoryService,
    WhatsappService,
    {
      provide: LOCALE_ID,
      useValue: 'pt'
    },
    {
      provide: DEFAULT_CURRENCY_CODE,
      useValue: 'BRL'
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorBase,
      multi: true
    },
    { provide: CURRENCY_MASK_CONFIG, useValue: customCurrencyMaskConfig }
  ],
  imports: [
    CommonModule,
    BsDatepickerModule.forRoot(),
    FontAwesomeModule,
    HighchartsChartModule,
    PrivadoRoutingModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTabsModule,
    NgbDatepickerModule,
    NgbPopoverModule,
    NgSelectModule,
    SharedModule,
    NgxMaskModule.forRoot(maskConfig),
    MatStepperModule,
    NgbModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PrivadoModule { }  